// extracted by css-extract-rspack-plugin
export default {"cellText":"cellText-Oh5VJz","emptyState":"emptyState-uvzTqE","emptyContent":"emptyContent-smKA2Q","tableContainer":"tableContainer-nfcRli","columnsButton":"columnsButton-VUZQZ9"};